<template>
  <div class="password-input-wrapper">
    <input
      :id="id"
      :type="showPassword ? 'text' : 'password'"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      class="password-input"
      autocomplete="new-password"
    />
    <button
      type="button"
      class="password-toggle"
      @click="togglePasswordVisibility"
      :disabled="disabled"
      :aria-label="showPassword ? 'Hide password' : 'Show password'"
    >
      <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Enter password'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPassword: false
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  },
  emits: ['input', 'focus', 'blur']
};
</script>

<style scoped>
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input {
    width: calc(100% - 80px);
    margin-bottom: 0px;
    height: 20px !important;
    padding: 10px 20px;
    padding-right: 50px;
    color: #222c3c;
    font-weight: normal;
    font-size: 14px;
    line-height: unset;
    font-weight: 500;
    border-radius: 5px;
    border: 1px solid #ced4da;
}

.password-input:focus {
  outline: none;
  border-color: #005EB8;
  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.2);
}

.password-input:disabled {
  background-color: #F0F4F5;
  cursor: not-allowed;
  opacity: 0.7;
}

.password-input::placeholder {
  color: #6C757D;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #6C757D;
  font-size: 16px;
  transition: color 0.2s ease;
  z-index: 1;
}

.password-toggle:hover {
  color: #495057;
}

.password-toggle:focus {
  outline: none;
}

.password-toggle:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.password-toggle i {
  pointer-events: none;
}
</style>